import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';
import { RegimenClass } from '@cureskin/api-client/src/server-api';
import { ExperimentService } from '@services/experiment/experiment.service';
import { RegimenService } from '@services/regimen-service/regimen.service';
import { AppConfig } from 'client/app/app.config';
import { getDisplayState, processRegimen } from 'client/app/user/user-view/user-regimen/regimen.utils';
import {
  REGIMEN_QUERY_PARAMS,
  REGIMEN_ROUTE_PATHS,
  REGIMEN_VIEW_STATES,
} from 'client/app/user/user-view/user-regimen/regimen.constants';

// A class with no regimen only resolves to EMPTY/CHAT, so the shell's consultation-session lookup is not needed here.
export const regimenReportTabGuard: CanActivateFn = async (
  route: ActivatedRouteSnapshot,
): Promise<boolean | UrlTree> => {
  const experimentService = inject(ExperimentService);
  const regimenService = inject(RegimenService);
  const router = inject(Router);
  const appConfig = inject(AppConfig);

  await experimentService.experimentsLoaded;

  const regimenClass = (route.queryParams[REGIMEN_QUERY_PARAMS.CLASS] as RegimenClass)
    || appConfig.Shared.Regimen.Class.FACE;
  const queryParams = { [REGIMEN_QUERY_PARAMS.CLASS]: regimenClass };

  const regimens = await regimenService.getRegimens();
  const regimen = regimens.find((r: { class?: string }): boolean => r.class === regimenClass) ?? null;
  const isUnpaid = getDisplayState(regimen && processRegimen(regimen)) === REGIMEN_VIEW_STATES.UNPAID;

  if (isUnpaid && experimentService.reportInRegimenPageExperiment) return true;

  if (isUnpaid) {
    return router.createUrlTree([REGIMEN_ROUTE_PATHS.ROOT, REGIMEN_ROUTE_PATHS.UNPAID], { queryParams });
  }
  return router.createUrlTree([REGIMEN_ROUTE_PATHS.ROOT], { queryParams });
};
